import React from 'react';
import { CKPadding } from '../Styles';
import View from './View';

const CKSpacer = () => {
    return <View style={{height: CKPadding.default * 2}} />;
}

export default CKSpacer;